import { Switch } from '@/components/ui/switch'
import { Separator } from '@/components/ui/separator'
import { cn } from '@/lib/utils'

const PERMISSION_GROUPS = [
  {
    label: 'Mini-CMS',
    permissions: [
      { key: 'manage_events', label: 'Gestionar eventos (crear/editar)' },
      { key: 'publish_events', label: 'Publicar e ir-en-vivo eventos' },
      { key: 'manage_announcements', label: 'Gestionar anuncios (borradores)' },
      { key: 'publish_announcements', label: 'Publicar anuncios' },
      { key: 'manage_success_stories', label: 'Gestionar casos de éxito' },
      { key: 'publish_success_stories', label: 'Publicar casos de éxito' },
    ],
  },
  {
    label: 'Hub corporativo (sensible)',
    permissions: [
      { key: 'edit_manager_profile', label: 'Editar perfil del Country Manager' },
      { key: 'edit_kpis', label: 'Editar KPIs' },
      { key: 'edit_faq', label: 'Editar FAQ' },
      { key: 'edit_support', label: 'Editar configuración de soporte' },
      { key: 'edit_branding', label: 'Editar branding (cover, accent color)' },
      { key: 'publish_hub', label: 'Publicar / despublicar el Hub' },
    ],
  },
  {
    label: 'Operaciones',
    permissions: [
      { key: 'generate_trial_codes', label: 'Generar códigos de prueba' },
      { key: 'view_partners_in_country', label: 'Ver partners del país' },
      { key: 'contact_partners', label: 'Contactar partners' },
    ],
  },
  {
    label: 'Equipo',
    permissions: [
      { key: 'invite_team_members', label: 'Invitar nuevos miembros' },
      { key: 'manage_team_permissions', label: 'Modificar permisos del equipo' },
    ],
  },
]

function PermissionsMatrix({ value = {}, onChange, disabled = false }) {
  const toggle = (key) => onChange({ ...value, [key]: !value[key] })

  return (
    <div>
      {disabled && (
        <p className="text-caption text-neutral-500 dark:text-neutral-400 mb-3">
          Los permisos individuales solo aplican cuando el rol es &quot;custom&quot;.
          Cambia el rol para editarlos.
        </p>
      )}
      <div className="space-y-5">
        {PERMISSION_GROUPS.map((group) => (
          <div key={group.label}>
            <p className="text-micro uppercase tracking-wide text-neutral-500 dark:text-neutral-400 font-semibold">
              {group.label}
            </p>
            <Separator className="my-1.5" />
            <ul className={cn('divide-y divide-neutral-100 dark:divide-neutral-800', disabled && 'opacity-60')}>
              {group.permissions.map((p) => (
                <li
                  key={p.key}
                  className="flex items-center justify-between gap-3 py-2.5"
                >
                  <span className="text-body-sm text-neutral-800 dark:text-neutral-200">{p.label}</span>
                  <Switch
                    checked={!!value[p.key]}
                    onCheckedChange={() => !disabled && toggle(p.key)}
                    disabled={disabled}
                  />
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  )
}

export default PermissionsMatrix
